import { defSimpleUnit, defAlias, defBaseUnit } from '../registry';

export const volumeUnits = [
  // SI
  defBaseUnit('liter'),
  defSimpleUnit('deciliter', 'liter', 1e-1),
  defSimpleUnit('centiliter', 'liter', 1e-2),
  defSimpleUnit('milliliter', 'liter', 1e-3),
  defSimpleUnit('kiloliter', 'liter', 1e3),

  defSimpleUnit('cubic_meter', 'liter', 1e3),

  // US customary system definitions, taken from
  // https://www.nist.gov/system/files/documents/2016/11/10/hb44-2017-web_final.pdf
  // Appendix C
  defSimpleUnit('cubic_inch', 'liter', 0.016387064),
  defSimpleUnit('cubic_foot', 'cubic_inch', 1728),
  // ccf which is a C (roman numerial C) 100 cubic foot
  defSimpleUnit('c_cubic_foot', 'cubic_foot', 100),
  // mcf which is a M (roman numerial M) 1000 cubic foot
  defSimpleUnit('m_cubic_foot', 'cubic_foot', 1000),
  defSimpleUnit('cubic_yard', 'cubic_foot', 27),

  defSimpleUnit('gallon', 'liter', 3.785411784),
  defSimpleUnit('kilogallon', 'gallon', 1000),
  defSimpleUnit('centigallon', 'gallon', 100),
  defSimpleUnit('quart', 'gallon', 0.25),
  defSimpleUnit('pint', 'gallon', 0.125),
  defSimpleUnit('cup', 'gallon', 0.0625),
  defSimpleUnit('fluid_ounce', 'liter', 0.0295735295625),

  defSimpleUnit('us_barrel', 'gallon', 31.5),
  defSimpleUnit('oil_barrel', 'gallon', 42),
  defSimpleUnit('hogshead', 'us_barrel', 2),

  defSimpleUnit('bushel', 'cubic_inch', 2150.42),
  defSimpleUnit('peck', 'bushel', 0.25),

  defSimpleUnit('teaspoon', 'fluid_ounce', 1 / 6),
  defSimpleUnit('tablespoon', 'fluid_ounce', 1 / 2),

  // Scientific
  defSimpleUnit('planck_volume', 'liter', 4.2217e-102),

  // Imperial
  defSimpleUnit('imperial_gallon', 'liter', 4.54609),
  defSimpleUnit('imperial_barrel', 'imperial_gallon', 36),
];

defAlias('l', 'liter');
defAlias('ml', 'milliliter');
defAlias('cc', 'milliliter');
defAlias('cl', 'centiliter');

defAlias('cgal', 'centigallon');
defAlias('gallons', 'gallon');
defAlias('oz', 'fluid_ounce');

defAlias('kilolitre', 'kiloliter');
defAlias('centilitre', 'centiliter');
defAlias('decilitre', 'deciliter');
defAlias('millilitre', 'milliliter');

// Standard cubic foot, which is a cubic foot but of a gas with specific conditions
defAlias('scf', 'cubic_foot');
defAlias('cf', 'cubic_foot');
defAlias('mcf', 'm_cubic_foot');
defAlias('ccf', 'c_cubic_foot');

// cubic meter of natural gas
defAlias('m3_natural_gas', 'cubic_meter');
